/* eslint-disable import/prefer-default-export */
export const REFERENCES_COUNT_MAX_VALUE = 500;
